export default "__VITE_ASSET__B3lzvLlh__"